import React, { useEffect, useRef, useState } from "react";
import { Loader2, Check } from "lucide-react";
import { AutoGrowTextarea } from "../AutoGrowTextarea";

/* 客户跟进（原客户画像）：记录首次沟通要点与客户特征，独立于现场调研表单，停止输入 1.5 秒后自动保存 */
export const CustomerProfileCard = ({ lead, zh, canEdit, onSave }) => {
  const [val, setVal] = useState(lead.primaryConcern || "");
  const [state, setState] = useState("idle"); // idle | dirty | saving | saved
  const dirtyRef = useRef(false);
  useEffect(() => { if (!dirtyRef.current) setVal(lead.primaryConcern || ""); }, [lead.primaryConcern]);
  useEffect(() => {
    if (state !== "dirty") return;
    const t = setTimeout(async () => {
      setState("saving");
      try { await onSave({ primaryConcern: val }); dirtyRef.current = false; setState("saved"); } catch { setState("dirty"); }
    }, 1500);
    return () => clearTimeout(t);
  }, [val, state]); // eslint-disable-line
  const status = state === "saving" ? [<Loader2 className="h-3 w-3 animate-spin" />, zh ? "保存中…" : "Saving…", "text-slate-400"]
    : state === "saved" ? [<Check className="h-3 w-3" />, zh ? "已自动保存" : "Auto-saved", "text-emerald-600"]
    : state === "dirty" ? [null, zh ? "输入停止后自动保存" : "Saves when you stop typing", "text-amber-600"] : null;
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5 space-y-2" data-testid="crm-customer-profile">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <p className="text-[11px] text-slate-500">{zh ? "首次沟通要点与客户特征：需求、顾虑、预算 / 时间考虑、决策人、下一步约定…" : "Key points from the first conversation and who the customer is: needs, concerns, budget / timing, decision maker, next steps…"}</p>
        {status && <span data-testid="crm-customer-profile-status" className={`text-[11px] inline-flex items-center gap-1 shrink-0 ${status[2]}`}>{status[0]}{status[1]}</span>}
      </div>
      <AutoGrowTextarea data-testid="crm-customer-profile-text" disabled={!canEdit} value={val} minRows={3}
        onChange={(e) => { dirtyRef.current = true; setVal(e.target.value); setState("dirty"); }}
        placeholder={zh ? "例如：业主夫妇 60 岁退休，想给女儿一家建 ADU；担心预算超支与审批周期；预算 25–30 万，希望明年 6 月前完工；决策人为先生…" : "e.g. Retired couple, building an ADU for their daughter; worried about budget overrun and permit timeline; budget $250–300k; target June next year…"}
        className="text-sm" />
    </div>
  );
};
